<template>
	<div>
		<div v-if="field.edittype === 'radiogroup'" class="formgroup-container">
			<div class="formgroup-heading">
				<strong>{{ $t(`form${capitalize(field.name)}`) }}<span v-if="field.required"> *</span></strong>
			</div>
			<div class="radiobuttons">
				<div v-for="(_value, key) in field.options" :key="key">
					<label>
						<input v-model="fieldRef.value" type="radio" :name="field.name" :value="key" />
						{{ $t(`form${capitalize(key)}`) }}
					</label>
				</div>
				<div v-if="!field.required">
					<label>
						<input type="radio" :name="field.name" value="" />
						{{ $t('formNoPreference') }}
					</label>
				</div>
			</div>
		</div>

		<div v-else-if="field.edittype === 'checkbox'" class="formgroup-container">
			<div class="checkboxes">
				<label :for="field.name">
					<input
						:id="field.name"
						v-model="fieldRef.value"
						:name="field.name"
						type="checkbox"
						:checked="!!field.value"
						:placeholder="$t(`form${capitalize(field.name)}`)"
						:required="field.required"
					/>
					{{ $t(`form${capitalize(field.name)}`) }}<span v-if="field.required"> *</span>
				</label>
			</div>
		</div>

		<div v-else-if="field.edittype === 'list'" class="select">
			<select :id="field.name" v-model="fieldRef.value" :name="field.name">
				<option v-if="!field.required" value="null" selected>
					{{ $t(`form${capitalize(field.name)}`) }}
				</option>
				<option v-for="(value, key) in field.options" :key="key" :value="value">
					{{ value }}
				</option>
			</select>
		</div>

		<div v-else-if="field.edittype === 'textarea'" class="textarea">
			<label> {{ $t(`form${capitalize(field.name)}`) }}<span v-if="field.required"> *</span> </label>
			<textarea
				:key="field.name"
				v-model="fieldRef.value as string"
				:name="field.name"
				:required="field.required"
			/>
		</div>

		<div v-else>
			<label> {{ $t(`form${capitalize(field.name)}`) }}<span v-if="field.required"> *</span> </label>
			<input
				:key="field.name"
				v-model="fieldRef.value as string"
				:name="field.name"
				:required="field.required"
				:type="getInputType(field.name)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	field: FormField;
}>();

const fieldRef = toRef(props, 'field');

const inputTypes: Record<string, string> = { email: 'email', phone: 'tel' };
const getInputType = (fieldName: string) => inputTypes[fieldName] ?? 'text';
</script>

<style lang="scss" scoped>
.formgroup-container {
	margin: 0 0 25px;

	.formgroup-heading {
		margin-bottom: 15px;
	}

	.checkboxes {
		display: flex;
		margin: 5px 0 10px;

		&.block {
			display: block;
		}

		.extra-option {
			margin: 15px 0 0;
		}

		label {
			width: auto;
			padding: 0;
			font-size: 0.9em;
			margin: 0 5px 0 0;
			display: flex;
			gap: 10px;
			align-items: center;

			input {
				width: auto;
				padding: 0;
				appearance: auto;
				margin: -2px 6px 0 0;
			}
		}
	}

	.radiobuttons {
		display: flex;
		flex-flow: row wrap;
		margin: 5px 0 10px;

		> div {
			width: 100%;
			margin: 0 0 10px;
		}

		label,
		input {
			width: auto;
			padding: 0;
			font-size: 0.9em;
		}

		label {
			margin: 0 5px 0 0;
			display: flex;
			gap: 10px;

			input {
				width: auto;
				appearance: auto;
				margin: -2px 6px 0 0;
				padding: 0;
			}
		}
	}
}
</style>
